import { useContext, useMemo, useRef } from "react";
import { IconLink, Icons, PageContainer } from "../shared";
import { MaxHeightContainer } from "../shared/charts/MaxHeightContainer";
import { GroupedReportConfigurations } from "./ReportComponents";
import { ReportContext, useReportTitle } from "./reportHelpers";

export const PrintReportContainer: React.FC<{ dataSource: string }> = ({ dataSource }) => {
    const reportContainer = useRef(null);
    const { reportConfig, searchParams, updateReportConfig } = useContext(ReportContext);
    if (!reportConfig) {
        throw new Error('must be used inside ReportContext');
    }
    const [title, titleRange] = useReportTitle(reportConfig);

    const titleElement = useMemo(() => {
        return title && (
            <h4><span className="mr-5">{title}</span>-
                {titleRange?.length && (<span className="ml-5">{titleRange}</span>)}
            </h4>);
    }, [title, titleRange]);

    const SelectedReport = useMemo(() => {
        const group = GroupedReportConfigurations.find(rc => rc.values.find(x => x.key === reportConfig.selectedReportId));
        return group?.values.find(x => x.key === reportConfig.selectedReportId);
    }, [reportConfig.selectedReportId]);
    const SelectedReportComponent = SelectedReport?.component;
    const downloadData = async () => {
        await SelectedReport?.downloadData?.(searchParams)
    };


    const toChart = (chartType: 'bar' | 'line') => { updateReportConfig({ ...reportConfig, chartType: chartType }) };

    return (<>
        <style>
            {`
                @media print {
                    body * { visibility: hidden !important; background-color: white; }
                    html, body, #root  { background: white !important; }
                    .print-area {position: absolute; left:0; top: 0; width: 100%;}
                    .print-area, .print-area * { visibility: visible !important; }
                }
            `}
        </style>
        <div ref={reportContainer} >

            <PageContainer title={titleElement} titleRight={(<>
                {(SelectedReport?.config?.allowsIgnoreStoppedTraffic ?? false) && <span className="me-10"><input type="checkbox" className="me-2" checked={reportConfig.ignoreStoppedTraffic} onChange={e => updateReportConfig({ ...reportConfig, ignoreStoppedTraffic: !reportConfig.ignoreStoppedTraffic })} />Ignore Stopped Traffic</span>}
                {!(SelectedReport?.config?.disallowChartTypeToggling ?? false) && reportConfig.chartType !== 'other' && <><label className="mr-2">
                    <input type="radio" name="chartType" value="bars" checked={reportConfig.chartType === 'bar'} onChange={e => toChart('bar')} className="mx-1" />
                    Bars
                </label>
                    <label className="mr-5">
                        <input type="radio" name="chartType" value="lines" checked={reportConfig.chartType === 'line'} onChange={e => toChart('line')} className="mx-1" />
                        Lines
                    </label>
                </>}
                <button onClick={() => window.print()}><IconLink Icon={Icons.Calendar}>Print</IconLink></button>
                {SelectedReport?.downloadData && <button><IconLink onClick={downloadData} Icon={Icons.Download}>Download</IconLink></button>}
            </>)} >

                <MaxHeightContainer className="print-area p-3" minHeight={300} margin={{ top: 0, bottom: 70, left: 0, right: -64 }}>{({ width, height }) => {
                    return SelectedReportComponent ? (<SelectedReportComponent size={{ height: height, width: width }} title={dataSource} subTitle={title + ' ‎ ‏ ‎ ' + titleRange} />) : (<></>);
                }}</MaxHeightContainer>
            </PageContainer>
        </div>
    </>);
}
//TODO: move report type selection to separate component and report props should probably live in a context (need to learn more react)